<dx-popup [visible]="Visible" (visibleChange)="visibleChange.emit($event)" (onHidden)="hidden()"
    [title]="'topupAttention.popupTitle' | transloco" [width]="'min(520px, 94vw)'" height="auto" [showCloseButton]="true" [hideOnOutsideClick]="false">
    <div *dxTemplate="let data of 'content'" class="p-3 space-y-5">
        <p>{{ 'topupAttention.popupHelp' | transloco }}</p>
        <div class="grid grid-cols-2 gap-4">
            <div class="rounded-lg bg-blue-50 p-4"><div>{{ 'topupAttention.pending' | transloco }}</div><strong class="text-3xl">{{ Model.PendingCount }}</strong></div>
            <div class="rounded-lg bg-orange-50 p-4"><div>{{ 'topupAttention.overdue' | transloco }}</div><strong class="text-3xl">{{ Model.OverdueCount }}</strong></div>
        </div>
        <div class="flex flex-wrap justify-end gap-3">
            <dx-button [text]="'topupAttention.later' | transloco" [height]="44" (onClick)="hide()"></dx-button>
            <dx-button [text]="'topupAttention.review' | transloco" [height]="44" type="default" stylingMode="contained" (onClick)="hide(true)"></dx-button>
        </div>
    </div>
</dx-popup>
